import jQuery from 'jquery';
let $ = jQuery;

import "../Cabinet.js";

/**
* class HSN.AccountNavigation.Cabinet.Drawer
*
* Encapsulates a single drawer for the HSN cabinet pairing a trigger for the
* drawer and the URL it's data should be loaded from.
**/
HSN.AccountNavigation.Cabinet.Drawer = function (config) {
    /**
     * new HSN.AccountNavigation.Cabinet.Drawer(config)
     * - config (Object): A configuration object for the [[HSN.AccountNavigation.Cabinet.Drawer]]
     *   consisting of the following keys:
     *   - identifier (String): The unique identifier of this drawer so it may be referenced directly within the context of a [[HSN.AccountNavigation.Cabinet]].
     *   - trigger (HTMLElement): The HTML element that should be the trigger for opening & closing the drawer.
     *   - url (String): The URL that the data for the drawer should be loaded from.
     *   - callback (Function): An optional callback function to execute once the drawer content has fully loaded.
     **/
    config = (config = config || {});

    this.Identifier = config.identifier;
    this.Callback = config.callback;
    this.CloseCallback = config.closeCallback;
    this.Trigger = $(config.trigger);
    this.Url = config.url;
    this.NoAjax = config.noajax;

    if (this.NoAjax) {
        this.Trigger.addClass('drawer-trigger-noajax');
    }

    this.Trigger.append('<span class="ir active-indicator"></span>');
};
HSN.AccountNavigation.Cabinet.Drawer.prototype = {
    /**
     * HSN.AccountNavigation.Cabinet.Drawer#Identifier -> String
     *
     * The unique identifier for this [[HSN.AccountNavigation.Cabinet.Drawer]] so it may be referenced directly within the context of a [[HSN.AccountNavigation.Cabinet]].
     **/
    Identifier: null,

    /**
     * HSN.AccountNavigation.Cabinet.Drawer#Callback -> Function | null
     *
     * [[HSN.AccountNavigation.Cabinet.Drawer#Function]] provides access to the optional callback that will be executed once a drawer has loaded.
     **/
    Callback: null,

    /**
         * HSN.AccountNavigation.Cabinet.Drawer#CloseCallback -> Function | null
         *
         * [[HSN.AccountNavigation.Cabinet.Drawer#Function]] provides access to the optional callback that will be executed once a drawer has closed.
    **/
    CloseCallback: null,

    /**
     * HSN.AccountNavigation.Cabinet.Drawer#Trigger -> jQuery
     *
     * [[HSN.AccountNavigation.Cabinet.Drawer#Trigger]] provides access to the jQuery-wrapped HTML element that is the drawer trigger.
     **/
    Trigger: null,
    
    /**
     * HSN.AccountNavigation.Cabinet.Drawer#Url -> String
     *
     * [[HSN.AccountNavigation.Cabinet.Drawer#Url]] provides access URL that the data for the drawer should be loaded from.
     **/
    Url: null,

    /**
     * HSN.AccountNavigation.Cabinet.Drawer#NoAjax -> Boolean
     *
     * [[HSN.AccountNavigation.Cabinet.Drawer#NoAjax]] provides access to a value to turn off the ajax Open functionality of the drawer.
    **/
    NoAjax: null
};



// WEBPACK FOOTER //
// ./assets/js/HSN/AccountNavigation/Cabinet/Drawer.js